import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navbar } from "../../components";
import { Footer } from "../../components";
import classes from "./Profile.module.css";
import AvatarImage from "../../assets/img/avatar.png";
import { Address } from "./Address";
import { PreviousOrders } from "./PreviousOrders";

const Profile = (props) => {
  const { t, i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState({
    tab: "profileInformation",
    title: "Profile Information",
  });
  const [tabs, setTabs] = useState([
    { id: 1, title: "Profile Information", tab: "profileInformation" },
    { id: 2, title: "Delivery Address", tab: "deliveryAddress" },
    { id: 3, title: "Previous Orders", tab: "previousOrders" },
  ]);
  const toggleTabs = (tab, title) => {
    setCurrentTab({ tab: tab, title: title });
  };
  return (
    <div className={`wrapper-container ${classes.wrapperContainer}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Profile</title>
        <body className="dynamic-class-for-body-on-this-view" />
      </Helmet>
      <Navbar />
      <div className={classes.profileContainer}>
        <div className={`container`}>
          <div className={classes.profileContent}>
            <div className={classes.profileLeft}>
              <div className={classes.profileAvatar}>
                <div className={classes.avatarImg}>
                  <img
                    src={AvatarImage}
                    alt={`Full Name`}
                    className={`img-fluid ${classes.avatar}`}
                  />
                  <button className={classes.changeAvatar}>
                    <span className={`icon-edit ${classes.editIcon}`}></span>
                    <input type="file" className={classes.changeAvatarAction} />
                  </button>
                </div>
              </div>
              <div className={classes.fullName}>Emad Samy</div>
              <div className={classes.balance}>0.00 EGP</div>
              <div className={classes.profileTabs}>
                {tabs.map((row, index) => {
                  return (
                    <button
                      className={`${classes.profileTabBtn} ${
                        row.tab === currentTab.tab ? classes.active : ""
                      }`}
                      onClick={() => toggleTabs(row.tab, row.title)}
                    >
                      {row.title}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className={classes.profileRight}>
              <div className={`${classes.tabContentCard}`}>
                <div className={classes.tabCardHeader}>{currentTab.title}</div>
                <div className={classes.tabCardBody}>
                  {currentTab.tab == "profileInformation" ? (
                    <div className={classes.profileInfo}>
                      <div className={classes.infoOuterRow}>
                        <div className={classes.infoData}>
                          <div className={classes.infoTitle}>
                            Number Phone:{" "}
                          </div>
                          <div className={classes.infoInput}>
                            <input type="text" value="01234567890" />
                            <div className={classes.changeInfo}>
                              <button className={classes.changeInfoBtn}>
                                Change Number
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={classes.infoOuterRow}>
                        <div className={classes.infoData}>
                          <div className={classes.infoTitle}>Full Name: </div>
                          <div className={classes.infoInput}>
                            <input type="text" value="Emad Samy" />
                          </div>
                        </div>
                      </div>

                      <div className={classes.infoOuterRow}>
                        <div className={classes.infoData}>
                          <div className={classes.infoTitle}>
                            <button className={classes.changeInfoBtn}>
                              Change Password
                            </button>
                          </div>
                          <div className={classes.infoInput}>
                            {/* <input type="text" value="01234567890" /> */}
                            <div className={classes.changeInfo}>
                              {/* <button className={classes.changeInfoBtn}>
                                Change Password
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={classes.infoOuterRow}>
                        <button className={`main-button`}>Update</button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {currentTab.tab == "deliveryAddress" ? <Address /> : ""}
                  {currentTab.tab == "previousOrders" ? <PreviousOrders /> : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export { Profile };
